package io.horion.cv.components.cards

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import io.horion.cv.utils.Colors
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaCalendar
import com.varabyte.kobweb.silk.components.icons.fa.FaFile
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import io.horion.cv.models.ApplyJob
import io.horion.cv.models.ApplyJobStatus
import io.horion.cv.utils.UserTestData

@Composable
fun CandidatCard(
    applyJob: ApplyJob,
    breakpoint: Breakpoint,
    onStatusChange: (ApplyJobStatus) -> Unit = {},
    onViewCV: (String) -> Unit = {},
    onViewLetter: (String) -> Unit = {}
) {

    val statusColor = when (applyJob.status) {
        ApplyJobStatus.PENDING -> Colors.secondary
        ApplyJobStatus.ACCEPTED -> Colors.Primary
        ApplyJobStatus.REJECTED -> Colors.Red
    }

    val statusText = when (applyJob.status) {
        ApplyJobStatus.PENDING -> "En attente"
        ApplyJobStatus.ACCEPTED -> "Acceptée"
        ApplyJobStatus.REJECTED -> "Rejetée"
    }

    val userName = UserTestData.getUserById(applyJob.user)?.nom ?: applyJob.user
    val userEmail = UserTestData.getUserById(applyJob.user)?.email ?: ""
    val userPhone = UserTestData.getUserById(applyJob.user)?.phone ?: ""


    Box(
        modifier = Modifier
            .fillMaxWidth()
            .margin(bottom = 12.px)
            .backgroundColor(Colors.White)
            .borderRadius(12.px)
            .border(1.px, LineStyle.Solid, Colors.LightGray)
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(16.px)
        ) {

            // HEADER
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically
            ) {

                // INFOS (gauche)
                Column(
                    modifier = Modifier.weight(1f),
                    verticalArrangement = Arrangement.spacedBy(4.px)
                ) {
                    // Afficher le nom de l'utilisateur
                    SpanText(
                        text = userName,
                        modifier = Modifier
                            .fontSize(if (breakpoint <= Breakpoint.MD) 18.px else 22.px)
                            .fontWeight(FontWeight.Bold)
                            .color(Colors.Black)
                    )

                    if (breakpoint > Breakpoint.MD && userEmail.isNotEmpty()) {
                        SpanText(
                            text = userEmail,
                            modifier = Modifier
                                .fontSize(14.px)
                                .color(Colors.Graytext)
                        )
                    }

                    Row(
                        horizontalArrangement = Arrangement.spacedBy(12.px),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Row(verticalAlignment = Alignment.CenterVertically) {
                         /*   Image(
                                src = "/calendar-black.svg",
                                description = "icone calendrier",
                                modifier = Modifier.size(18.px)
                            )*/

                            FaCalendar(
                                size = IconSize.LG,
                                //modifier = Modifier.color(Colors.Blue)
                            )
                            SpanText(
                                text = " ${formatDate(applyJob.createdAt)}",
                                modifier = Modifier
                                    .fontSize(18.px)
                                    .color(Colors.Graytext)
                            )
                        }

                        Box(
                            modifier = Modifier
                                .backgroundColor(statusColor.copy(alpha = 5))
                                .borderRadius(20.px)
                                .padding(leftRight = 8.px, topBottom = 4.px)
                        ) {
                            SpanText(
                                text = statusText,
                                modifier = Modifier
                                    .fontSize(18.px)
                                    .color(statusColor)
                                    .fontWeight(FontWeight.Medium)
                            )
                        }
                    }
                }

                // ACTIONS (droite)
                Row(
                    horizontalArrangement = Arrangement.spacedBy(8.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {

                    // Accepter / Rejeter seulement si PENDING
                    if (applyJob.status == ApplyJobStatus.PENDING) {
                        Button(
                            onClick = { onStatusChange(ApplyJobStatus.ACCEPTED) },
                            modifier = Modifier
                                .backgroundColor(Colors.White)
                                .borderRadius(6.px)
                                .border(1.px, LineStyle.Solid, Colors.secondary)
                                .padding(8.px)
                        ) {
                            SpanText("✔", modifier = Modifier.color(Colors.White))
                        }

                        Button(
                            onClick = { onStatusChange(ApplyJobStatus.REJECTED) },
                            modifier = Modifier
                                .backgroundColor(Colors.White)
                                .borderRadius(6.px)
                                .border(1.px, LineStyle.Solid, Colors.Red)
                                .padding(8.px)
                        ) {
                            SpanText("✖", modifier = Modifier.color(Colors.White))
                        }
                    }

                    Button(
                        onClick = { /* voir profil */ },
                        modifier = Modifier
//                            .backgroundColor(Colors.LighterBlue)
                            .borderRadius(6.px)
                            .border(1.px, LineStyle.Solid, Colors.LighterBlue)
                            .padding(8.px)
                    ) {
                        SpanText("👤", modifier = Modifier.color(Colors.White))
                    }
                }
            }

            // CONTENU (toujours visible maintenant)
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .margin(top = 16.px),
                verticalArrangement = Arrangement.spacedBy(12.px)
            ) {

                // CV
                Row(
                    horizontalArrangement = Arrangement.spacedBy(8.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Row(verticalAlignment = Alignment.CenterVertically){
                       /* Image(
                            src = "/documentIcone.avif",
                            description = "icone lettre",
                            modifier = Modifier.size(18.px)
                        )*/
                        FaFile(
                            size = IconSize.LG,
                            //modifier = Modifier.color(Colors.Blue)
                        )
                        SpanText(
                            text = " CV:",
                            modifier = Modifier
                                .fontSize(18.px)
                                .fontWeight(FontWeight.Bold)
                                .color(Colors.Black)
                        )
                    }
                    SpanText(
                        text = applyJob.cv,
                        modifier = Modifier
                            .fontSize(18.px)
                            .color(Colors.LighterBlue)
                            .cursor(Cursor.Pointer)
                            .onClick { onViewCV(applyJob.cv) }
                    )
                }
            }
        }
    }
}
// Fonction  pour formater la date
private fun formatDate(dateString: String): String {
    return try {
        val date = dateString.split("T")[0]
        val parts = date.split("-")
        if (parts.size == 3) {
            "${parts[2]}/${parts[1]}/${parts[0]}"
        } else {
            dateString
        }
    } catch (e: Exception) {
        dateString
    }
}